import { useMemo } from 'react';
import { useRouter } from 'next/navigation';
import Button from 'components/gruenland/atoms/button/Button';
import Typography from 'components/gruenland/atoms/typography';
import { useFormat } from 'helpers/hooks/useFormat';
import { TYPOGRAPHY_PAGE_TITLE_2 } from 'lib/typography';

type AlterFormProps = {
  page: 'login' | 'register';
};
type PageBasedData = { [key in AlterFormProps['page']]: { title: string; buttonLabel: string; link: string } };

const AlterForm: React.FC<AlterFormProps> = ({ page }) => {
  const router = useRouter();
  const { formatMessage } = useFormat({ name: 'gruenland' });

  const pageBasedData: PageBasedData = useMemo(() => {
    return {
      login: {
        title: formatMessage({ id: 'user.welcomeBack', defaultMessage: 'Bentornato' }),
        buttonLabel: formatMessage({ id: 'user.signIn', defaultMessage: 'Accedi' }),
        link: '/login',
      },
      register: {
        title: formatMessage({ id: 'user.notMemberYet', defaultMessage: 'Non sei ancora iscritto?' }),
        buttonLabel: formatMessage({ id: 'user.register', defaultMessage: 'Registrati' }),
        link: '/register',
      },
    };
  }, [formatMessage]);

  const title = useMemo(() => pageBasedData[page].title, [page, pageBasedData]);
  const buttonLabel = useMemo(() => pageBasedData[page].buttonLabel, [page, pageBasedData]);

  const handleClick = () => {
    router.push(pageBasedData[page].link);
  };

  return (
    <div className="mt-9 border-t border-t-neutral-400 pt-10 md:mt-[56px] md:pt-[56px] lg:mt-[84px] lg:pt-[84px]">
      <div className="m-auto grid max-w-screen-sm px-4">
        <Typography as="h3" className={TYPOGRAPHY_PAGE_TITLE_2}>
          {title}
        </Typography>
        <Button className="mt-4 md:mt-6" variant="buttonSecondary" onClick={handleClick}>
          {buttonLabel}
        </Button>
      </div>
    </div>
  );
};

export default AlterForm;
